import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntry} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY} from '../../brand'

/**
 * Hook to fetch sidecard data from Contentstack
 * Transforms Contentstack fields to component format
 *
 * Note: If no data is found in Contentstack, returns null and component falls back to product.c_sidecard
 */
let prefix = ''
if (BRAND_KEY === 'kenwood' || BRAND_KEY === 'braun') prefix = `${BRAND_KEY}_`

export const useGetSidecard = () => {
    const contentstack = useContentstack()
    const stack = contentstack?.stack
    const {locale} = useMultiSite()

    const getSidecardData = async () => {
        // Return null if stack not initialized
        if (!stack || !locale?.alias) {
            return null
        }

        try {
            const contentTypeUid = `${prefix}product_sidecard`

            const response = await getEntry({
                stack,
                contentTypeUid,
                locale: locale.alias,
            })

            if (!response) {
                return null
            }

            const rawData = response

            // Transform Contentstack fields to component format
            return {
                title: rawData?.sidecardTitle || '',
                bodyCopy: rawData?.sidecardSubtitle || '',
                image: rawData?.sidecardImage || '',
                sections: [
                    {
                        id: 'section_1',
                        title: rawData?.sidecardEditorialSection1?.title || '',
                        subtitle: rawData?.sidecardEditorialSection1?.subtitle || '',
                    },
                    {
                        id: 'section_2',
                        title: rawData?.sidecardEditorialSection2?.title || '',
                        subtitle: rawData?.sidecardEditorialSection2?.subtitle || '',
                    },
                    {
                        id: 'section_3',
                        title: rawData?.sidecardEditorialSection3?.title || '',
                        subtitle: rawData?.sidecardEditorialSection3?.subtitle || '',
                    },
                    {
                        id: 'section_4',
                        title: rawData?.sidecardEditorialSection4?.title || '',
                        subtitle: rawData?.sidecardEditorialSection4?.subtitle || '',
                    },
                ].filter((section) => section.title || section.subtitle),
            }
        } catch (error) {
            return null
        }
    }

    return useQuery(['contentstackGetSidecard', locale?.alias], () => getSidecardData(), {
        staleTime: 1000 * 60 * 60, // 1 hour
    })
}
